<template>
  <div class="w100 mw100" :style="{ backgroundImage: `url(${require('../../public/img/tabbar/bottom_bg.png')})` }"
    style="background-repeat: no-repeat;background-size: cover;">
    <div class="pcScreen">
      <div style="position: relative;z-index: 9;display: flex;">
        <div style="flex: 1;text-align: center;padding-top: 2%;">
          <img style="width: 20%;height: auto;" :src="logoblack" alt="" />
        </div>
        <div style="flex: 1;">
          <div v-for="(item) in skipList" :key="item.name" style="text-align: center;">
            <el-button style="color: #ffffff;font-size: max(12px, 1.2vw);margin-top: 3%;" type="text" @click="skip(item.url)">{{ item.name
              }}</el-button>
          </div>
        </div>
        <div style="flex: 1;">
          <div style="font-size: max(12px, 1.2vw);margin-top: 3%;">联系我们</div>
          <div v-for="item in informationList" :key="item.msg"
            style="display: flex;align-items: center;margin-top: 8%;">
            <div style="width: 4%;margin-right: 2%;display: flex;justify-content: center;align-items: center;">
              <img style="width: 100%;height: auto;" :src="item.icon" alt="" />
            </div>
            <div style="color: #ffffff;font-size: max(10px, 1vw);width: 80%;">{{ item.msg }}</div>
          </div>
        </div>
      </div>
      <div style="font-size: max(10px, 1vw);text-align: center;margin-top: 3%;">
        技术支持：上海泺阳信息科技有限公司
      </div>
      <div style="font-size: max(10px, 1vw);cursor: pointer;color: #fff;text-align: center;margin-top: 1%;"
        @click="bottomSkip()">
        Copyright ©上海泺阳信息科技有限公司 沪ICP备2024091271号
      </div>
    </div>

    <div class="mobileScreen">
      <div style="position: relative;z-index: 9;display: flex;">
        <div style="flex: 1;text-align: center;padding-top: 3vw;">
          <img style="width: 30%;height: auto;" :src="logoblack" alt="" />
        </div>
        <div style="flex: 1;">
          <div v-for="(item) in skipList" :key="item.name" style="text-align: center;">
            <el-button style="color: #ffffff;font-size: 2vw;" type="text" @click="skip(item.url)">{{ item.name
              }}</el-button>
          </div>
        </div>
        <div style="flex: 1;">
          <div style="font-size: 2vw;margin-top: 3vw;">联系我们</div>
          <div v-for="item in informationList" :key="item.msg"
            style="display: flex;align-items: center;margin-top: 3vw;">
            <div style="width: 5%;margin-right: 1vw;display: flex;justify-content: center;align-items: center;">
              <img style="width: 100%;height: auto;" :src="item.icon" alt="" />
            </div>
            <div style="color: #ffffff;font-size: 1.5vw;width: 80%;">{{ item.msg }}</div>
          </div>
        </div>
      </div>
      <div style="font-size: 1.1vw;text-align: center;margin-top: 3vw;">
        技术支持：上海泺阳信息科技有限公司
      </div>
      <div style="font-size: 1.1vw;cursor: pointer;color: #fff;text-align: center;margin-top: 2vw;"
        @click="bottomSkip()">
        Copyright ©上海泺阳信息科技有限公司 沪ICP备2024091271号
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        logoblack: require("../../public/img/tabbar/logoComposite1.png"),

        skipList: [
          { name: "首页", url: "/" },
          // { name: "信息服务优势", url: "/trends" },
          { name: "关于我们", url: "/partner" },
          { name: "学习中心", url: "/consultation" },
          { name: "行业资讯", url: "/news" },
        ],

        informationList: [
          {
            msg: "4000038286",
            icon: require("../../public/img/footer/footer_icon.png"),
          },
          {
            msg: "lizemin@lyhost.com",
            icon: require("../../public/img/footer/footer_icon2.png"),
          },
          {
            msg: "上海市金山工业区亭卫公路6495弄168号5幢3楼",
            icon: require("../../public/img/footer/footer_icon3.png"),
          },
        ],
      };
    },

    methods: {
      skip(url) {
        this.$router.push(url);
      },
      bottomSkip() {
        location.href = 'https://beian.miit.gov.cn/'
      }
    },
  };
</script>

<style scoped>
  a {
    text-decoration: none;
    color: #fff;
  }

  .w100 {
    width: 100%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .pcScreen {
    display: block;
  }

  .mobileScreen {
    display: none;
  }

  @media screen and (max-width: 750px) {
    .pcScreen {
      display: none;
    }

    .mobileScreen {
      display: block;
    }

    .mw100 {
      width: 100vw;
    }
  }
</style>